module.exports = __webpack_public_path__ + "img/mtc_svg.7eb2c042.svg";